document.addEventListener("DOMContentLoaded", function () {
  const protectedproducts = { "riley-day-gift-card" : "test2"};
  const uuids = ['ec5e4009-5e78-4a34-879f-699b1c9eb7cc', 'e9e7b4a3-1ec5-446e-9b9d-546ca703d57d', 'cd410831-8819-4ce2-981f-0eb5365f890d', 'e186a2b7-d4a1-477a-b6d4-75ae2a46a66b', 'c77b7e4b-91dd-4a6f-86c4-d69954e34262', '16620441-6d6e-4e69-9827-d4d8e65a17fb', '03a4d249-98ce-4e26-8d38-2e6f5b700a4c', 'f98a8e94-97af-4754-a346-3f9e0dfdd9cc', 'c1c8b7df-6824-4986-bc71-df380b29d7f1', 'f19bc2e2-6b4b-4ce7-8c78-89b999dbf693'];

  const getProductHandleFromUrl = () => {
    const url = new URL(window.location.href);
    const pathSegments = url.pathname.split("/");
    return pathSegments[pathSegments.length - 1];
  };

  var token = new URLSearchParams(window.location.search).get('token');
  if (token && uuids.includes(token)) {
    // console.log("token",token)
  }else{
    const currentProductHandle = getProductHandleFromUrl();
    console.log("currentProductHandle", currentProductHandle)
    let isCustomer = document.getElementById("is_active_customer").value;
    let isExclusive = document.getElementById("is_product_exclusive").value;
    if(!isCustomer && isExclusive == 'true'){
      // window.location.href="/account/login";
      window.location.href="/pages/custom-register?redirectTo=products/"+currentProductHandle;
    }
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   const protectedproducts = { "riley-day-gift-card" : "test2"};

//   const getProductHandleFromUrl = () => {
//     const url = new URL(window.location.href);
//     const pathSegments = url.pathname.split("/");
//     return pathSegments[pathSegments.length - 1];
//   };

//   const currentProductHandle = getProductHandleFromUrl();

//   if (Object.keys(protectedproducts).includes(currentProductHandle)) {
//     const mainContent = document.querySelector("main");
//     const originalContent = mainContent.innerHTML;

//     const createFormHtml = () => {
//       return `
// <div id="password-protected-container">
// <form id="password-protected-form">
// <label for="password-protected-input">Enter the password to view the product:</label>
// <input type="password" id="password-protected-input" />
// <button id="password-protected-button" type="submit">Submit</button>
// </form>
// <p id="password-protected-error" style="display: none; color: red;">Incorrect password. Please try again.</p>
// </div>`;
//     };

//     mainContent.innerHTML = createFormHtml();

//     const form = document.getElementById("password-protected-form");
//     const input = document.getElementById("password-protected-input");
//     const error = document.getElementById("password-protected-error");
//     const productModal = document.querySelector('product-modal');
//     productModal.style.display = "none";
//     form.addEventListener("submit", (e) => {
//       e.preventDefault();

//       if (input.value === protectedproducts[currentProductHandle]) {
//         mainContent.innerHTML = originalContent;
//         productModal.style.display = "block";
//       } else {
//         error.style.display = "block";
//         productModal.style.display = "none";
//       }
//     });
//   }
// });